import Vue from 'vue';
import Vuex from 'vuex';
import login from './modules/login';
import app from './modules/app';
import saleData from './modules/saleData';
import stepperState from './modules/stepperState';
Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		login,
		app,
		saleData,
		stepperState
	}
});
